import reducer from './reducers';
import * as voiceAnalysesActions from './actions';
import * as voiceAnalysesSelectors from './selectors';

export { voiceAnalysesActions, voiceAnalysesSelectors };
export default reducer;
